import { NgIf,NgClass } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { MessageModule } from 'primeng/message';
@Component({
    selector: 'app-oa-installed',
    imports: [TableModule, DropdownModule, FormsModule, NgIf, NgClass, MessageModule],
    templateUrl: './oa-installed.component.html',
    styleUrl: './oa-installed.component.scss'
})
export class OaInstalledComponent {
  installedData: any[] = [];
  filterdInstalledData: any[] = [];
  dropDownData: any[] = [];
  selectedDivision: any = '';
  @Input() setOAData: any;
  constructor(private router: Router){
  }
  ngOnChanges(changes: SimpleChanges): void {
    // This lifecycle hook is called whenever an input property changes

    if (changes['setOAData']) {
      if (this.setOAData) {
        this.processOAData();
      }
    }
  }

  processOAData(){
    this.installedData = this.setOAData.tblOAAll_Installed;
    this.installedData.map((item: any) => {
      if (item.tlr_status === 'I') {
        item.status = 'Installed';
        item.cssClass = 'green'
      } else if (item.tlr_status === 'P') {
        item.status = 'Pre Installation';
        item.cssClass = 'blue'
      } else if (item.tlr_status === 'R') {
        item.status = 'Removed';
        item.cssClass = 'red'
      }
    })
    if(this.setOAData.Division_I) {
      this.dropDownData = this.setOAData.Division_I.map((item: any) => {
        return { label: item, value: item };
      });
    }
    this.selectedDivision = this.dropDownData[0].value;
    this.filterInstalledData();
  }

  details(row: any){
    this.router.navigate(['/details-section', row.tag_number]);
  }

  assignToMe(row : any){
    localStorage.setItem('oA_action_type', 'Insert');
    this.router.navigate(['/oa-compliance-details-section', row.tag_number]);

  }
  onDivisionChange(){
    this.filterInstalledData();
  }

  filterInstalledData( ){
     this.filterdInstalledData = this.installedData.filter((item: any) => {
      return item.division_name === this.selectedDivision;
    });
  }
}
